export default {
  currentStripePlan: {},
  stripePlans: [],
}
